export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'pl', name: 'Polski',  flag: '🇵🇱' },
];
export const defaultLang = 'en';